import React from "react";
import Checkbox from "../../../../common/checkbox/Checkbox";
import Box from "../../../../common/box/Box";

// TODO Consider making this a common component if needed
function Consent({ label, content, accepted, onChange }) {
  return (
    <Box statusIndicatorPosition={"left"} statusIndicatorColor={accepted ? "green" : "grey"}>
      <div className="content">
        <Checkbox
          label={label}
          labelClassName={"has-text-grey-dark is-size-6 has-text-weight-bold"}
          checked={accepted}
          onChange={onChange}
        />
        <p className="pl-5 is-size-6">{content}</p>
      </div>
    </Box>
  );
}

export default Consent;
